import React from 'react';
import PropTypes from 'prop-types';
import { Switch, FormControlLabel } from '@mui/material';

const SwitchBase = React.forwardRef(
  ({ label, field: { name, value, onChange }, form: { setFieldValue, setFieldTouched }, ...props }, ref) => {
    const handleChange = (event) => {
      const newValue = event.target.checked;
      setFieldTouched(name, true);
      setFieldValue(name, newValue, false);
      // Llamar onChange después de setFieldValue para mantener sincronización
      if (onChange) {
        // Crear un evento sintético con el nuevo valor
        const syntheticEvent = {
          ...event,
          target: {
            ...event.target,
            checked: newValue
          }
        };
        onChange(syntheticEvent);
      }
    };

    // Asegurar que el valor sea explícitamente boolean
    // Manejar diferentes tipos de valores (boolean, number, string)
    const checkedValue = value === true || value === 1 || value === '1' || value === 'true';

    return (
      <FormControlLabel
        control={
          <Switch 
            id={name} 
            inputRef={ref} 
            checked={checkedValue} 
            value={name} 
            onChange={handleChange} 
            {...props} 
          />
        }
        label={label}
      />
    );
  }
);

SwitchBase.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.any])
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldTouched: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired
  }).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func
};

SwitchBase.defaultProps = {
  label: ''
};

export default SwitchBase;
